
import Vue, { PropType } from "vue";
import { Company } from "@/models";
import { setVacanCompanyId } from "@/api";
import BaseTableCellContent from "@/components/BaseTableCellContent.vue";

export type DataType = {
  showing: boolean;
};

export default Vue.extend({
  name: "CompanyListItem",

  components: {
    BaseTableCellContent,
  },
  computed: {
    formattedCompanyId(): string {
      return this.company.id?.slice(0, 6) || "";
    },
    buildingName(): string {
      return this.company.facilityName || "";
    },
  },

  props: {
    company: Object as PropType<Company>,
  },

  methods: {
    accessToCompanyPage(): void {
      if (this.company == null) return; // this.$toasted.global.error('予期せぬ不具合が発生しました')
      if (this.company.id == null) return; // this.$toasted.global.error('予期せぬ不具合が発生しました')

      setVacanCompanyId(this.company.id);
      this.$router.push({ path: "/company/gateways" });
    },

    setSelectedCompany(): void {
      const companyId = this.company?.id;
      if (companyId) {
        this.$auth.setCompanyId(companyId);
        this.$globalData.setCompany(this.company);
        this.$router.push({ name: "company-analytics-detail" });
      }
    },
  },
});
